const LOGO_URL = "https://customer-assets.emergentagent.com/job_maine-web/artifacts/qoipmzpw_WhatsApp%20Image%202023-11-30%20at%2017.56.14_ac124f9d.jpg";

export const Footer = () => {
  return (
    <footer
      data-testid="main-footer"
      className="relative bg-[#070A0E] border-t border-[#F5F1EA]/10 pt-20 pb-8 overflow-hidden"
    >
      {/* Huge brand mark */}
      <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 pointer-events-none select-none">
        <div className="font-display font-bold uppercase text-[18vw] leading-none text-white/[0.025] tracking-tighter whitespace-nowrap">
          NIRYASA
        </div>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          {/* Brand */}
          <div className="md:col-span-5 flex flex-col gap-5">
            <div className="flex items-center gap-3">
              <img
                src={LOGO_URL}
                alt="Niryasa Industries"
                className="h-14 w-14 object-cover rounded-full border border-brand-red/40"
              />
              <div>
                <div className="font-display text-xl font-bold uppercase tracking-wider text-white">
                  Niryasa Industries
                </div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-brand-red">Pvt Ltd</div>
              </div>
            </div>
            <p className="text-sm text-white/55 leading-relaxed max-w-md font-sans">
              Trusted Indian manufacturer of welding cables and rubber welding hoses — engineering quality &amp; delivering trust since 2014.
            </p>
          </div>

          {/* Links */}
          <div className="md:col-span-3 flex flex-col gap-4">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/45 mb-1">Navigate</div>
            {["Home", "About", "Products", "Why Us", "Contact"].map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase().replace(" ", "-")}`}
                data-testid={`footer-link-${item.toLowerCase().replace(" ", "-")}`}
                className="text-sm text-white/70 hover:text-brand-red transition-colors w-fit"
              >
                {item}
              </a>
            ))}
          </div>

          {/* Contact */}
          <div className="md:col-span-4 flex flex-col gap-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/45 mb-1">Reach Us</div>
            <a
              href="tel:9899928308"
              data-testid="footer-phone"
              className="text-sm text-white hover:text-brand-red transition-colors w-fit"
            >
              +91 9899928308
            </a>
            <a
              href="mailto:contact@niryasaindustries.com"
              data-testid="footer-email-1"
              className="text-sm text-white/70 hover:text-brand-red transition-colors w-fit break-all"
            >
              contact@niryasaindustries.com
            </a>
            <a
              href="mailto:niryasaindustries@gmail.com"
              data-testid="footer-email-2"
              className="text-sm text-white/70 hover:text-brand-red transition-colors w-fit break-all"
            >
              niryasaindustries@gmail.com
            </a>
            <div className="text-sm text-white/55 leading-relaxed mt-2 max-w-xs">
              Village Ramnagar, Ganaur,<br /> Haryana 131039, India
            </div>
          </div>
        </div>

        {/* Bottom strip */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8">
          <div data-testid="footer-copyright" className="text-xs text-white/40 uppercase tracking-[0.2em]">
            © {new Date().getFullYear()} Niryasa Industries Pvt Ltd. All rights reserved.
          </div>
          <div className="flex items-center gap-6 text-xs text-white/40 uppercase tracking-[0.2em]">
            <span>Since 2014</span>
            <span className="w-1 h-1 bg-brand-red rounded-full" />
            <span>Made in India</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
